import Pikaday from 'pikaday';

$('.field-wrapper label').on('click',function() {
	var thisWrapper = $(this).closest('.field-wrapper');
	$(thisWrapper).addClass('has-value');
	var thisId = $(this).attr('for');
	setTimeout(function() {
		$(thisWrapper).find('input#' + thisId).focus();	
	},500);
});

$('.field-wrapper input').on('focus',function() {
	var thisInput = $(this);
	var thisWrapper = $(this).closest('.field-wrapper');
	$(thisWrapper).addClass('has-value');
});

$('.field-wrapper input').on('blur',function() {
	var thisInput = $(this);
	var thisWrapper = $(this).closest('.field-wrapper');
	if($(thisInput).val().length === 0) {
		$(thisWrapper).removeClass('has-value');		
	}
});

$(document).on('submit','.fullwidth_cta_wrapper form',function(e){
	if($(this).find('input[type="text"]').val() == '') {
		e.preventDefault();
		$(this).find('.field-wrapper').addClass('error');		
		$(this).find('.form-error').html('There was an error with your submission: please enter a search term.').addClass('show');		
	}
});

function handleFormSubmission(){
  $('.form input').on('keyup', function(e){
    $(this).addClass('edited');
  });

  $('.form [type="submit"]').on('click.formValidation', function(e){
    var shouldPrevent = false;
    var errorList = [];


    var $form = $(this).parents('form');
    var $inputs = $form.find('input[required], textarea[required], select[required]');

    $inputs.each(function(index, input){
      var labelSelector = 'label[for="' + $(input).attr('id') + '"]';
      var error = $form.find(labelSelector).closest('.field-wrapper, .input-group').find('.error-message')
      error.removeAttr('aria-live');
      error.css('display', 'none');

      if(!input.validity.valid){
        error.css('display', 'inline-block');
        shouldPrevent = true;
        errorList.push(error);

      }
      else {
        error.css('display', 'none');
      }
    });

    if(!$form[0].checkValidity()){
      e.preventDefault();
      errorList[0].attr('aria-live', 'assertive');
    }
  });
}

var datePickers = document.querySelectorAll('.datepicker');
var datePickersLength = datePickers.length;
for(i = 0; i < datePickersLength; i++) {
  new Pikaday({
    field: document.getElementById(datePickers[i].getAttribute('id')),
    format: 'MM/DD/YYYY',
  });
}

$(document).ready(function() {
  $('form .field-wrapper input').each(function( index ) {
    var thisInput = $(this);
    if($(thisInput).val().length > 0) {
      var thisWrapper = $(this).closest('.field-wrapper');
      $(thisWrapper).addClass('has-value');
    }
  });

  handleFormSubmission();
});

// Handle completion for Request an Appointment form
$('input[type=radio][name=same_patient_info]', '.appointment-form').change(function() {
  var form = $('.appointment-form');
  var title = form.find('#patient-title').val();
  var firstName = form.find('#patient-first-name').val();
  var lastName = form.find('#patient-last-name').val();
  var email = form.find('#patient-email').val();
  var phone = form.find('#patient-phone').val();
  var contactTitle = form.find('#contact-title');
  var contactFirstName = form.find('#contact-first-name');
  var contactLastName = form.find('#contact-last-name');
  var contactEmail = form.find('#contact-email');
  var contactPhone = form.find('#contact-phone');
  if (this.value == 'yes') {
    contactTitle.val(title);
    contactFirstName.val(firstName);
    contactLastName.val(lastName);
    contactEmail.val(email);
    contactPhone.val(phone);
    $("input[id^='contact']").each(function( index ) {
      $(this).closest('.field-wrapper').addClass('has-value');
    });
  }
  else if (this.value == 'no') {
    $("input[id^='contact']").each(function( index ) {
      $(this).val('');
      $(this).closest('.field-wrapper').removeClass('has-value');
    });
  }
});